import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";

import { useGetSSNRequiredStatesConfiguration } from "./useGetSSNRequiredStatesConfiguration";

/**
 * Hook that provides a function to check if SSN is required before submitting a license.
 *
 * SSN is required when:
 * 1. Worker doesn't have an SSN
 * 2. SSN requirement feature is enabled
 * 3. Either the license state OR worker's address state is in the SSN-required states list
 */
export function useIsSsnRequired() {
  const worker = useDefinedWorker();
  const ssnRequiredStatesConfiguration = useGetSSNRequiredStatesConfiguration();

  function checkIsSsnRequired(licenseState?: string): boolean {
    if (worker.socialSecurityNumber) {
      return false;
    }

    if (!ssnRequiredStatesConfiguration.enabled) {
      return false;
    }

    const licenseStateRequiresSsn = Boolean(
      licenseState && ssnRequiredStatesConfiguration.states.includes(licenseState)
    );

    const workerStateRequiresSsn = Boolean(
      worker.address?.state && ssnRequiredStatesConfiguration.states.includes(worker.address.state)
    );

    return licenseStateRequiresSsn || workerStateRequiresSsn;
  }

  return { checkIsSsnRequired };
}
